import countries from 'world-countries';

/**
 * Get country display with flag emoji and full name
 * @param countryCode - ISO 3166-1 alpha-3 country code (e.g., 'IND', 'USA')
 * @returns Formatted string with flag emoji and country name (e.g., '🇮🇳 India')
 */
export function getCountryDisplay(countryCode: string | null | undefined): string {
  if (!countryCode) {
    return '-';
  }

  // Find country by alpha-3 code
  const country = countries.find((c) => c.cca3.toUpperCase() === countryCode.toUpperCase());

  if (!country) {
    // If not found, return the code as-is
    return countryCode;
  }

  // Return flag emoji + country name
  return `${country.flag} ${country.name.common}`;
}

/**
 * Get just the country name without flag
 * @param countryCode - ISO 3166-1 alpha-3 country code (e.g., 'IND', 'USA')
 * @returns Country name (e.g., 'India')
 */
export function getCountryName(countryCode: string | null | undefined): string {
  if (!countryCode) {
    return '-';
  }

  const country = countries.find((c) => c.cca3.toUpperCase() === countryCode.toUpperCase());

  return country ? country.name.common : countryCode;
}

/**
 * Get country flag emoji
 * @param countryCode - ISO 3166-1 alpha-3 country code (e.g., 'IND', 'USA')
 * @returns Flag emoji (e.g., '🇮🇳')
 */
export function getCountryFlag(countryCode: string | null | undefined): string {
  if (!countryCode) {
    return '';
  }

  const country = countries.find((c) => c.cca3.toUpperCase() === countryCode.toUpperCase());

  return country ? country.flag : '';
}
